/**
 * Service Worker registration — the ONE place that calls register().
 *
 * Other services (FCM, web-push) MUST use `navigator.serviceWorker.ready`
 * instead of calling register() themselves — otherwise we end up with race
 * conditions and noisy logs.
 *
 * On update: a `swUpdateAvailable` CustomEvent is dispatched on window with
 * { detail: registration }. The React <PWAUpdatePrompt/> listens for this
 * and shows a "Доступна новая версия" toast. Clicking it postMessages
 * SKIP_WAITING to the new SW, then reloads when it takes control.
 */
export function register() {
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/sw.js`;

    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        // Check for an update right away (and again every hour for long-lived tabs)
        registration.update().catch(() => {});
        setInterval(() => registration.update().catch(() => {}), 60 * 60 * 1000);

        registration.onupdatefound = () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.onstatechange = () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              // New version is waiting. Notify the app.
              window.dispatchEvent(new CustomEvent('swUpdateAvailable', { detail: registration }));
            }
          };
        };
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('SW registration failed:', error);
      });

    // When the new SW takes control, reload once so the new bundle is used.
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  });
}

export function unregister() {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    // eslint-disable-next-line no-console
    .catch((err) => console.error(err.message));
}
